<style lang="less" scoped>
</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
                    <div class="flex detail-form-parent-div">
                        <div class="flex-1">
                            <el-form-item label="用户名" prop="userName">
                                <el-input v-model="detailForm.userName" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="设置密码" prop="userPassword" v-if="!editFlag">
                                <el-input v-model="detailForm.userPassword" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="账号描述" prop="describe">
                                <el-input v-model="detailForm.describe" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="账号状态" prop="status">
                                <el-select class="full-width" v-model="detailForm.status" size="small" clearable>
                                    <el-option v-for="(item,index) in statueArr" :label="item.configName" :value="item.configVal" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                            <!-- <el-form-item label="账号归属" prop="dataCheck">
                                <el-radio-group v-model="detailForm.dataCheck">
                                    <el-radio label="N">在职</el-radio>
                                    <el-radio label="Y">离职</el-radio>
                                </el-radio-group>
                            </el-form-item> -->
                        </div>
                        <div class="flex-1">
                            <el-form-item label="手机号" prop="userPhone">
                                <el-input v-model="detailForm.userPhone" size="small" :disabled = 'editFlag'></el-input>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="email">
                                <el-input v-model="detailForm.email" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="角色权限" prop="roleId">
                                <el-select class="full-width" v-model="detailForm.roleId" size="small" clearable >
                                    <el-option v-for="(item,index) in roleArr" :label="item.roleName" :value="item.roleId" :key="index" @click.native="handleRoleChange(item.roleName)"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
                <button class="common-empty-button" @click="resetForm">取 消</button>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,
                pageTitle:'用户新增',
                // 默认值设置
                detailForm: {},
                statueArr:[],
                roleArr:[],
            }
        },
        methods: {
            init() {
                this.detailForm.dealNo = this.$store.state.userInfo.dealNo
                if(this.$store.state.editId){
                    this.editFlag = true;
                    this.pageTitle = "用户编辑";
                    this.getFormInfo();
                }
                this.getConfig();
            },
            // 获取表单信息
            getFormInfo(){
                let _ = this;
                _.$S.getFormInfo(_,_.$A.user.list +'/'+_.$store.state.editId,function(res){
                     _.detailForm = res.data.data;
                });
            },
            getConfig(){
                let _ = this;
                _.$H.post(_,_.$A.config.list,{configType:"192"}).then(res => {
                    _.statueArr = res.data.data;
                })
                let obj = {};
                let dealerNo = _.$store.state.userInfo.dealNo;
                if(dealerNo){
                    obj.dealerNo = dealerNo;
                }
                _.$H.post(_,_.$A.role.allrole,obj).then(res => {
                    _.roleArr = res.data.data;
                })
            },
                
            // 表单提交
            submitForm(formName) {
                let _ = this;
                _.detailForm.corpNo = _.$store.state.corpNo;
                _.detailForm.dealerNo = _.$store.state.userInfo.dealNo;
                _.detailForm.dataCheck= 'Y'
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _.$S.submitForm(_, _.$A.user.list, _.editFlag, _.detailForm, pageConfig.listRouter);
                    }
                });
            },
            handleRoleChange(val){
                this.detailForm.roleName = val;
            },
            // 取消
            resetForm() {
                this.$router.push({
                    name: pageConfig.listRouter
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>